import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#seatbelt-clip0_2249_1799)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "M21.707 1.707A1 1 0 0 0 20.293.293L16.98 3.606l-1.262-1.302a1 1 0 0 0-1.425-.011l-2 2A1 1 0 0 0 12 5v2.586L9.793 9.793a1 1 0 0 0 0 1.414l3 3a1 1 0 0 0 1.414 0L16.414 12H19a1 1 0 0 0 .707-.293l2-2a1 1 0 0 0 0-1.414L20.414 7l3.293-3.293a1 1 0 0 0-1.414-1.414l-3.304 3.304-.595-.577zM16.273 5.75l2.025 1.964L19.586 9l-1 1H16a1 1 0 0 0-.707.293L13.5 12.086 11.914 10.5l1.793-1.793A1 1 0 0 0 14 8V5.414l.989-.989 1.262 1.302zm-8.566 5.544a1 1 0 0 0-1.496.093l-3.5 4.5a1 1 0 0 0 .082 1.321l.293.293-2.793 2.793a1 1 0 1 0 1.414 1.414L4.5 18.914l.586.586-2.793 2.793a1 1 0 1 0 1.414 1.414L6.5 20.914l.293.293a1 1 0 0 0 1.32.082l4.5-3.5a1 1 0 0 0 .094-1.496zm-2.876 5.124 2.263-2.909 3.398 3.398-2.91 2.263zm16.876-.71a1 1 0 0 0-1.414-1.414L16 18.586V17a1 1 0 1 0-2 0v4a1 1 0 0 0 1 1h4a1 1 0 1 0 0-2h-1.586z",
        "clip-rule": "evenodd"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "seatbelt-clip0_2249_1799" }, [
        _createElementVNode("path", {
          fill: "currentColor",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }